import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children, requiredPermission }) => {
    const { user, permissions, isVerifying } = useAuth();

    // 1. Mientras se valida la sesión con la API, se muestra un Loader
    if (isVerifying) {
        return (
            <div className="flex h-screen w-full items-center justify-center">
                <div className="w-12 h-12 border-4 border-[#CE010B] border-t-transparent rounded-full animate-spin"></div>
            </div>
        );
    }

    // 2. Si no hay una sesión activa, expulsamos al visitante al Landing Page
    if (!user) {
        return <Navigate to="/" replace />;
    }

    // 3. BLINDAJE ULTRA-MAESTRO: Ignora cualquier requerimiento y da acceso total
    if (user?.role?.toLowerCase().trim() === 'maestro') {
        return children;
    }

    // 4. VALIDACIÓN DE PERMISOS ORDINARIOS
    if (!requiredPermission) return children;

    if (permissions && permissions.includes(requiredPermission)) {
        return children;
    }

    // Si no cumple el permiso, lo devuelve al Dashboard seguro
    return <Navigate to="/admin/dashboard" replace />;
};

export default ProtectedRoute;